export class Timetoken {
  readonly token: string;
  readonly timestamp: number;

  readonly datetime: Date;

  constructor(
    _token: string | number
  ) {
    if (_token == null) {
      throw new Error('Parameter \'_token\' cannot be nullish.');
    }

    this.token = _token.toString();

    let timestr = this.token;
    // pubnub reports timestamp in nanosecond precision
    if (this.token.length === 17) {
      timestr = this.token.substring(0, this.token.length - 4);
    }
    const timenum = parseInt(timestr, 10);
    this.timestamp = Math.floor(timenum / 1000) * 1000;

    this.datetime = new Date(this.timestamp);
  }

  // timetoken is 1000x more 'precise' than seconds, and is too big for a js number
  // we can convert to a 'second' precision timestamp by chopping off last 4 digits and rounding to nearest 1000

  static fromDate(date: Date): Timetoken {
    // eslint-disable-next-line prefer-template, no-useless-concat
    const ts = date.valueOf() + '' + '0000';
    return new Timetoken(ts);
  }
}
